import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PlutoOffers from '../plutoComp/PlutoOffers';
import PlutoOfferWalls from '../plutoComp/PlutoOfferWalls';
import PlutoChargebacks from '../plutoComp/PlutoChargebacks';
import PlutoFingerDet from '../plutoComp/PlutoFingerDet';
import PlutoIPDet from '../plutoComp/PlutoIPDet';
import PlutoPendingOffers from '../plutoComp/PlutoPendingOffers';
import PlutoSupportList from '../plutoComp/PlutoSupportList';
import PlutoSupportUser from '../plutoComp/PlutoSupportUser';
import PlutoSuspectOffers from '../plutoComp/PlutoSuspectOffers';
import PlutoUser from '../plutoComp/PlutoUser';
import PlutoUsers from '../plutoComp/PlutoUsers';
import PlutoWuthdrawal from '../plutoComp/PlutoWuthdrawal';
import PlutoSingleWithdrawal from '../plutoComp/PlutoSingleWithdrawal';
import PlutoHome from '../plutoComp/PlutoHome';
import DocumentMeta from 'react-document-meta';
import PlutoOfferDataTotal from '../plutoComp/PlutoOfferDataTotal';
import PlutoOfferDataTotalToday from '../plutoComp/PlutoOfferDataTotalToday';
import VerifyAdmin from "./PlutoVerify";
import { socket } from "../Containers/MainContainer";
import PlutoMenu from "./PlutoMenu";
import PlutoOffersToday from "./PlutoOffersToday";
import PlutoPendingPTC from "./PlutoPendingPTC";
import PlutoWithdrawalsToday from "./PlutoWithdrawalsToday";
import PlutoPaidCashOffers from "./PlutoPaidCashOffers";
import PlutoInvoices from "./PlutoInvoices";
import PlutoSameEmail from "./PlutoSameEmail";
import PlutoOffersFastComp from "./PlutoOffersFastComp";
import OffersAnalyticsDashboard from "./PlutoOffersAnalytics";
import '../../index.css';
import PlutoSuggestedPendingOffers from "./PlutoSuggestedPendingOffers";

// Loading spinner component
const LoadingSpinner = () => (
  <div className="min-h-screen bg-gray-900 flex items-center justify-center">
    <div className="flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      <p className="text-gray-400">Loading admin panel...</p>
    </div>
  </div>
);

// Main content wrapper component
const ContentWrapper = ({ children }) => (
  <div className="min-h-screen bg-gray-900">
    {children}
  </div>
);

export const AdminHome = (props) => {
  const [checkedIPInList, setCheckIPInList] = useState(false);
  const { referral_id, page, second_page, third_page } = useParams();
  const [isIPInTrusted, setISIPInTrusted] = useState(false);

  useEffect(() => {
    socket.emit('adminAction', {
      action: 'check_ip_trusted_admin'
    });

    socket.on('emitVerificationCodeAdmin', () => {
      socket.emit('adminAction', {
        action: 'check_ip_trusted_admin'
      });
    });

    socket.on('adminIPInTrustedList', (data) => {
      setCheckIPInList(true);
      setISIPInTrusted(data.status);
      window.dispatchEvent(new Event("end_loading"));
    });

    return () => {
      socket.off('emitVerificationCodeAdmin');
      socket.off('adminIPInTrustedList');
    };
  }, []);

  // Render the appropriate component based on the route
  const renderContent = () => {
    if (!second_page) return <PlutoHome />;

    switch (second_page) {
      case 'offers':
        return <PlutoOffers />;
      
      case 'chargebacks':
        return <PlutoChargebacks />;
      
      case 'offer-total':
        return <PlutoOfferDataTotal second_page={third_page} />;
      
      case 'offer-today':
        return <PlutoOfferDataTotalToday second_page={third_page} />;
      case 'suggested-pending-offers':
        return <PlutoSuggestedPendingOffers second_page={third_page} />;
      
      case 'offer-analytics':
        return <OffersAnalyticsDashboard second_page={third_page} />;
      
      case 'fingerprint':
        return third_page ? <PlutoFingerDet second_page={third_page} /> : <div>Select a fingerprint</div>;
      
      case 'emails':
        return third_page ? <PlutoSameEmail second_page={third_page} /> : <div>Select an email</div>;
      
      case 'ip':
        return third_page ? <PlutoIPDet second_page={third_page} /> : <div>Select an IP</div>;
      
      case 'offerwalls':
        return <PlutoOfferWalls />;
      
      case 'pc-offers':
        return <PlutoPaidCashOffers />;
      
      case 'ptcs':
        return <PlutoPendingPTC />;
      
      case 'pending-offers':
        return third_page ? 
          <PlutoPendingOffers x={1} second_page={third_page} /> : 
          <PlutoPendingOffers x={0} />;
      
      case 'support-chat':
        return third_page ? 
          <PlutoSupportUser second_page={third_page} /> : 
          <PlutoSupportList />;
      
      case 'suspect-offers':
        return <PlutoSuspectOffers />;
      
      case 'user':
        return third_page ? 
          <PlutoUser second_page={third_page} /> : 
          <PlutoUsers />;
      
      case 'withdrawals-today':
        return <PlutoWithdrawalsToday />;
      
      case 'offers-today':
        return <PlutoOffersToday />;
      
      case 'offer-fastc':
        return <PlutoOffersFastComp />;
      
      case 'invoices':
        return <PlutoInvoices />;
      
      case 'withdrawals':
        return third_page ? 
          <PlutoSingleWithdrawal second_page={third_page} /> : 
          <PlutoWuthdrawal />;
      
      default:
        return <PlutoHome />;
    }
  };

  // Check if user has admin access
  if (!props.rank || props.rank <= 1 || !props.logged) {
    return (
     <></>
    );
  }

  // Show loading spinner while checking IP
  if (!checkedIPInList) {
    return <LoadingSpinner />;
  }

  // Show verification if IP is not trusted
  if (!isIPInTrusted) {
    return (
      <ContentWrapper>
        <VerifyAdmin />
      </ContentWrapper>
    );
  }

  // Main admin interface
  return (
     <div className="flex h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Sidebar */}
           <PlutoMenu rank={props.rank} user_id={props.user_id} />


      {/* Main Content Wrapper */}
      <div className="flex flex-col flex-1 min-w-0">
       
        
        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto  bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
          <div className="max-w-7xl mx-auto mt-5 pt-5">
           {renderContent()}
          </div>
        </main>
      </div>
    </div>
    
  );
};